<template>
  <div class="gp-content">
    <content-nav-bar>
      <h5 class="is-size-4 has-text-centered level-item">Create Profile</h5>
      <a v-on:click="submit()" class="add button level-item">
        <i class="far fa-save"></i>
        Save
      </a>
      <loader class="level-item" :showLoader="showLoader">Creating Profile</loader>
    </content-nav-bar>
    <profile-edit-create :profile.sync="profile">
    </profile-edit-create>
  </div>
</template>

<script>
// import Ajv from 'ajv';
import ProfileEditCreate from '@/components/profiles/ProfileEditCreate.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'ProfileCreate',
  components: {
    ProfileEditCreate,
    ContentNavBar,
    Loader,
  },
  async mounted() {
    const actionConfigs = await this.$store.dispatch('primary/listActionConfigs', {
      direction: 'DESC',
      field: 'created',
    });
    this.actionConfigsOptions = actionConfigs.items;
  },
  computed: {
    computedProfile() {
      return {
        name: this.profile.name,
        description: this.profile.description,
        autoUpdate: this.profile.autoUpdate,
        actionConfigs: this.profile.actionConfigs,
        infoSync: JSON.stringify(this.profile.infoSync),
      };
    },
  },
  methods: {
    async submit() {
      // const ajv = new Ajv();
      // // const validate = ajv.addSchema(this.$typeDefs.schemas.infoSync)
      // //   .compile(this.$typeDefs.schemas.profile);
      // let validate = ajv.compile(this.$typeDefs.schemas.profile);
      // let valid = validate(this.computedProfile);
      // if (!valid) {
      //   console.log(validate.errors);
      //   return;
      // }

      // validate = ajv.compile(this.$typeDefs.schemas.infoSync);
      // valid = validate(JSON.parse(this.computedProfile.infoSync));
      // if (!valid) {
      //   console.log(validate.errors);
      //   // return;
      // }

      this.showLoader = true;
      const profile = await this.$store.dispatch('primary/createProfile', this.computedProfile);
      this.showLoader = false;
      if (profile) {
        this.$router.push({
          name: 'profiles.index.analytics',
          params: { id: profile.id },
          query: { new: 'true' },
        });
      }
    },
  },
  data() {
    return {
      showLoader: false,
      profile: this.$typeDefs.configs.profile,
    };
  },
};
</script>

<style lang="scss" scoped>

.profile-form {
  padding: 0 $content-padding;
}

.profile-form, .profile-button {
  margin-top: $content-padding;
}
</style>
